import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { DeployBannerComponent } from "#root/core/layout/common/deploy-banner/deploy-banner.component";

@NgModule({
  declarations: [DeployBannerComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  exports: [DeployBannerComponent],
})
export class DeployBannerModule {}
